<script>
  import { onMount } from 'svelte';
  import { isMobile } from '$lib/device.js';
  import DesktopMessenger from '../desktop/DesktopMessenger.svelte';
  import MobileMessenger from '../mobile/MobileMessenger.svelte';
  import CallManager from '../calls/CallManager.svelte';

  onMount(() => {
    const viewportLockClass = 'messenger-viewport-lock';
    const appViewportClass = 'messenger-app-viewport';
    document.documentElement.classList.add(viewportLockClass);
    document.body.classList.add(viewportLockClass);
    document.getElementById('app')?.classList.add(appViewportClass);

    return () => {
      document.documentElement.classList.remove(viewportLockClass);
      document.body.classList.remove(viewportLockClass);
      document.getElementById('app')?.classList.remove(appViewportClass);
    };
  });
</script>

<div class="messenger-shell">
  {#if $isMobile}
    <MobileMessenger />
  {:else}
    <DesktopMessenger />
  {/if}
  <CallManager />
</div>

<style>
  .messenger-shell {
    width: 100%;
    height: 100dvh;
    max-height: 100dvh;
    min-height: 0;
    overflow: hidden;
    color: #0f172a;
    background: #f8fafc;
  }

  :global(html.messenger-viewport-lock),
  :global(body.messenger-viewport-lock) {
    height: 100%;
    min-height: 0;
    overflow: hidden;
    overscroll-behavior: none;
  }

  :global(#app.messenger-app-viewport) {
    height: 100dvh;
    min-height: 0;
    overflow: hidden;
  }
</style>
